<template>
  <div class="thumb-swiper relative">
    <swiper
      class="h-full relative show-animate bg-cover bg-center"
      :style="{
        backgroundImage:
          'url(' +
          currentThree.bg.md +
          '?x-oss-process=image/resize,h_100' +
          ')'
      }"
      :options="swiperOption"
      ref="mySwiper"
      v-if="list.length > 0"
    >
      <swiper-slide v-for="(item, index) in list" :key="'swiper' + index"
        ><a
          class="banner-wrapper flex items-center block swiper-lazy"
          :href="item.link.herf ? item.link.herf : 'javascript:void(0)'"
          :target="item.link.herf ? '_blank' : ''"
          :data-background="item.bg.md"
          @click="toggleToAutoPlay()"
        >
          <!-- <div class="swiper-lazy-preloader swiper-lazy-preloader-white"></div> -->
          <div
            class="swiper-text-content text-white pl-20 swiper-lazy-loaded"
            v-show="
              (item.title.zh || item.content.zh) && index === currentIndex
            "
          >
            <p
              v-if="item.title.zh"
              class="mb-4 text-left font-bold"
              style="font-size: 30px"
            >
              {{ item.title.zh }}
            </p>
            <p
              v-if="item.content.zh"
              class="text-left"
              style="font-size: 14px; line-height: 1.5"
              v-html="item.content.zh.replace(/(\;|\；)/g, '<br>')"
            ></p>
          </div>
        </a>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper-slide>
    </swiper>
    <div class="thumb-pagination flex z-10">
      <div class="image-wrapper cursor-pointer">
        <div class="allThreeLevel">
          <p
            v-for="(item, index) in categroryList"
            :key="'ronghe' + index"
            :class="[parentIndex == index ? 'active' : '']"
            @click.stop="gotoCategory(index, true)"
          >
            {{ item.parent_name }}
          </p>
        </div>
        <template v-if="currentThree">
          <img
            :src="currentThree.bg.md + '?x-oss-process=image/resize,h_100'"
            alt=""
          />
          <div class="mask flex items-center text-font-16 p-8 text-brighter">
            {{ currentThree.parent_name }}
          </div>
        </template>
      </div>

      <div class="flex items-center relative bg-brighter control-wrapper">
        <div class="direction flex">
          <div
            @click="goPre"
            class="bg-white w-10 h-10 flex justify-center items-center cursor-pointer"
          >
            <i class="el-icon-arrow-left text-font-24"></i>
          </div>
          <div
            @click="goNext"
            class="bg-black w-10 h-10 flex justify-center items-center cursor-pointer"
          >
            <i class="el-icon-arrow-right text-white text-font-24"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import image1 from '@/assets/images/home/img1.jpeg'
import image2 from '@/assets/images/home/img2.jpeg'
export default {
  components: {
    swiper,
    swiperSlide
  },
  props: ['parentArr', 'swiperList', 'threeId', 'fourId', 'noScroll'],
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper
    // },
    categroryList() {
      return this.threeLevelArr.map(c => {
        return {
          ...c[0]
        }
      })
    },
    currentThree() {
      if (this.list.length > 0) {
        return this.list[0]
      } else {
        return null
      }
    }
  },
  watch: {
    currentIndex(newVal, oldVal) {
      console.log('======newVal====' + newVal)
      console.log('=====oldVal=====' + oldVal)
      console.log('====this.threeLevelArr.length==' + this.threeLevelArr.length)
      if (this.threeLevelArr.length === 1) return
      if (oldVal === this.list.length - 1 && newVal === 0) {
        console.log('=======gotoCategory')
        if (this.parentIndex + 1 <= this.threeLevelArr.length - 1) {
          this.gotoCategory(this.parentIndex + 1)
        } else {
          this.gotoCategory(0)
        }
      }
    }
  },
  mounted() {
    let threeLevelArr = []
    let currentThreeIndex = 0
    this.parentArr.forEach((parent, pindex) => {
      if (this.threeId && parent.id === this.threeId) {
        currentThreeIndex = pindex
      }
      threeLevelArr[pindex] = []
      this.swiperList.forEach((item, index) => {
        if (item.parent_id === parent.id) {
          threeLevelArr[pindex].push(item)
        }
      })
    })
    this.threeLevelArr = threeLevelArr
    console.log('=====this.threeLevelArr===')
    console.log(this.threeLevelArr)
    this.list = this.threeLevelArr[this.parentIndex]
    if (this.list.length == 1) {
      setTimeout(() => {
        this.gotoCategory(this.parentIndex + 1)
      }, 7 * 1000)
    }
    if (this.threeId) {
      this.$nextTick(() => {
        let currentThreeItem = this.threeLevelArr[currentThreeIndex]
        let initFourIdx = currentThreeItem.findIndex(c => c.id == this.fourId)
        console.log('==initFourIdx==' + initFourIdx)
        // this.swiperOption.initialSlide = initFourIdx
        this.gotoCategory(currentThreeIndex)
        setTimeout(() => {
          this.$refs.mySwiper.swiper.slideTo(initFourIdx)
        }, 100)
      })
    }
  },
  data() {
    let self = this
    return {
      autoplay: true,
      parentIndex: 0,
      currentIndex: 0,
      threeLevelArr: [],
      timer: null,
      list: [],
      count: 0,
      observer: true,
      observeParents: true,
      swiperOption: {
        disableOnInteraction: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
          loadOnTransitionStart: true
        },
        on: {
          slideChange: function() {
            console.log('=====self.count====')
            console.log(self.count)
            self.currentIndex = this.realIndex
            self.count = this.realIndex
          }
        },
        effect: 'fade',

        speed: 1000,
        preventInteractionOnTransition: false,
        // pagination: {
        //   el: '.swiper-pagination'
        // },
        mousewheel: {
          enabled: false
        },
        keyboard: {
          enabled: false
        },

        grabCursor: true,
        autoplay: this.noScroll
          ? false
          : {
              delay: 6000,
              stopOnLastSlide: false,
              disableOnInteraction: false
            }
      }
    }
  },
  methods: {
    toggleToAutoPlay() {
      console.log('====toggleToAutoPlay====')
      console.log(this.$refs.mySwiper.swiper)
      console.log(this.$route.name)
      // if (this.$route.name == 'company-profile') {
      //   this.swiperOption.autoplay = false
      //   this.$refs.mySwiper.swiper.autoplay.stop()
      // }
    },
    clearTimer() {
      this.timer && clearTimeout(this.timer)
    },
    gotoCategory(index, shouldEmptyList) {
      console.log(
        '====gotoCategory====this.threeLevelArr.length=' +
          this.threeLevelArr.length
      )
      if (this.threeLevelArr.length == 1) return
      this.count = 0
      this.currentIndex = 0
      this.parentIndex = index
      // shouldEmptyList && (this.list = [])
      this.$forceUpdate()
      this.list = []
      // this.list = this.threeLevelArr[index]
      this.$nextTick(() => {
        this.list = this.threeLevelArr[index]
        console.log('======list=====')
        console.log(this.list)
        if (this.list.length === 1 && !this.noScroll) {
          //当 swiper 中只有一张图片的时候，定时自动跳到下一章
          this.timer = setTimeout(() => {
            this.goNext()
            this.clearTimer()
          }, 6 * 1000)
        }
      })
    },
    goNext() {
      console.log('====')
      console.log(this.$refs.mySwiper.swiper)
      if (this.threeLevelArr.length === 1) {
        if (this.currentIndex === this.list.length - 1) {
          this.$refs.mySwiper.swiper.slideToLoop(0)
        } else {
          this.$refs.mySwiper.swiper.slideNext()
        }
      } else {
        this.count++
        if (this.count < this.list.length) {
          this.$refs.mySwiper.swiper.slideNext()
        } else {
          if (this.parentIndex + 1 <= this.threeLevelArr.length - 1) {
            this.gotoCategory(this.parentIndex + 1, true)
          } else {
            this.gotoCategory(0, true)
          }
        }
      }
    },
    goPre() {
      if (this.threeLevelArr.length === 1) {
        if (this.currentIndex === 0) {
          this.$refs.mySwiper.swiper.slideToLoop(this.list.length - 1)
        } else {
          this.$refs.mySwiper.swiper.slidePrev()
        }
      } else {
        this.count--
        if (this.count < 0) {
          if (this.parentIndex === 0) {
            this.gotoCategory(this.parentArr.length - 1, true)
          } else {
            this.gotoCategory(this.parentIndex - 1, true)
          }
        } else {
          this.$refs.mySwiper.swiper.slidePrev()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeScale {
  from {
    // opacity: 0;
    transform: scaleX(0);
  }
  to {
    // opacity: 1;
    transform: scaleX(1);
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0%);
  }
}
.thumb-swiper {
  height: 100vh;
  position: relative;
  background-color: white;
  .show-animate {
    animation: fadeIn 2s ease;
  }
  .swiper-lazy-loaded {
    // animation: fadeIn 1s ease;
  }
  // height: (9/16) * 100vw;
  .banner-wrapper {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
  .swiper-text-content {
    position: relative;
    padding: 25px 48px 25px;
    background-color: rgba(0, 0, 0, 0.3);
    color: white;
    left: 40px;
    will-change: transform;
    transform-origin: left;
    animation: fadeScale 1.5s ease;
  }
  .thumb-pagination {
    position: absolute;
    bottom: 48px;
    right: 66px;
    width: 280px;
    height: 94px;
    .image-wrapper {
      width: 190px;
      height: 94px;
      position: relative;
      &:hover {
        .allThreeLevel {
          display: block;
        }
      }
      .allThreeLevel {
        position: absolute;
        bottom: 100%;
        max-height: 65vh;
        overflow-y: scroll;
        right: 0;
        left: 0;
        z-index: 999;
        display: none;
        animation: slideUp 0.3s ease;
        background-color: rgba(0, 0, 0, 0.68);

        /* no-touchevents class is added by modernizr
 * as we don't want to apply this on touch devices */
        overflow-y: scroll;
        &::-webkit-scrollbar {
          background: rgba(0, 0, 0, 0.1);
          border-radius: 2px;
          height: 4px;
          width: 4px;
          display: block;
        }

        &::-webkit-scrollbar-thumb {
          background: #fdb732;
          border-radius: 2px;
        }
        p {
          width: 100%;
          height: 44px;
          line-height: 44px;
          text-align: center;
          color: #fdb732;
          font-size: 16px;
          overflow: hidden;
          &.active {
            color: white;
            background-color: #fdb732;
          }
        }
      }
      .mask {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
        color: #fdb732;
        font-size: 16px;
        li {
          text-align: center;
          width: 100%;
          height: 44px;
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .control-wrapper {
      width: 90px;
    }
  }
  .direction {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(50%, -50%);
  }
}
</style>
